import React from 'react';

const PostRate = (props) => {
    const {
        rate,
    } = props;

    let ratesTag = <p className="cpt-post-rates">
        from
        <span> ${rate} </span>
        <span>per night</span>
  </p>

    return ratesTag;
}

export default PostRate;